import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import { Outlet } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import CustomMenuList from "./Menu";
import { Grid2, Stack, Backdrop, CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import DrawIcon from "@mui/icons-material/Draw";
import "./style.css";
import Patrocinadores from "../patrocinio/Patrocinadores";
const admin_service = require("../../helpers/admin_service");
const pages = [
  { label: "Inicio", href: "/" },
  {
    label: "Patrocinio",
    href: `/patrocinio`,
  },
  {
    label: "Programa",
    //href: "/programa",
    href: "/programa",
  },
  {
    label: "Registro",
    href: "/registro",
  },

  /* {
     label: "Tarifas de Inscripción",
     href: "/tarifas",
   },*/
  /* {
    label: "Talleres",
    href: "/talleres",
  },*/

  /*{
    label: "Galeria",
    href: "/galeria",
  },*/
];
function ScrollTop(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

export default function Layout(props) {
  const [contador] = useState(0);
  const [loading, setLoading] = useState(true);
  const [patrocinadores, setPatrocinadores] = useState({});

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  function ElevationScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 0,
      target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
      elevation: trigger ? 4 : 0,
    });
  }

  ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
  };
  useEffect(() => {
    admin_service
      .getData("/patrocinador/view-by-evento/" + process.env.REACT_APP_EVT)
      .then((response_patrocinador) => {
        setPatrocinadores(response_patrocinador.data.response.result);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [contador]);
  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar
        style={{
          backgroundColor: "white",
          color: "#1e3d52",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Stack spacing={2} style={{ width: "100%" }}>
              <Grid2 container justifyContent="center">
                <Grid2
                  size={{ xs: 4, md: 4, lg: 4 }}
                  alignContent="center"
                  textAlign="center"
                >
                  <img
                    src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/d8c6579f-2920-4e8b-8361-7ae891313fe4.png"
                    loading="lazy"
                    className="img-header"
                  />
                </Grid2>
                <Grid2 size={{ xs: 4, md: 4, lg: 4 }}></Grid2>
                <Grid2
                  size={{ xs: 4, md: 4, lg: 4 }}
                  style={{ textAlign: "center" }}
                >
                  <img
                    src="https://test-escuelabancaria.s3.us-east-2.amazonaws.com/Medios+General/Logotipos+Finales+ABG+2022-01.png"
                    loading="lazy"
                    className="img-header"
                  />
                </Grid2>
              </Grid2>
              <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", md: "none" },
                  }}
                >
                  {pages.map((page, index) => (
                    <MenuItem
                      key={`MENU-ITEM-${index}`}
                      onClick={() => {
                        window.location.href = page.href;
                      }}
                    >
                      <ListItemText
                        style={{ color: "#1e3d52", fontWeight: "bold" }}
                      >
                        {page.label}
                      </ListItemText>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>

              <Box
                sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
                justifyContent="center"
                alignItems={"center"}
              >
                {pages.map((page, index) => (
                  <MenuItem
                    key={`MENU-ITEM-${index}`}
                    onClick={handleCloseNavMenu}
                  >
                    <CustomMenuList title={page.label} href={page.href} />
                  </MenuItem>
                ))}
              </Box>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
      <Toolbar id="back-to-top-anchor" />
      <Box className="container-outlet">
        <Stack>
          <Outlet />
          {patrocinadores.length > 0 && (
            <Patrocinadores
              evt={process.env.REACT_APP_EVT}
              patrocinadores={patrocinadores}
            />
          )}
          <Box style={{ width: "100%" }}>
            <Stack
              spacing={15}
              direction="row"
              justifyContent="center"
              alignContent="center"
              p={5}
            >
              <a
                href="https://www.facebook.com/abg.ebg"
                target="_blank"
                style={{ color: "black", textDecoration: "none" }}
              >
                <FacebookIcon style={{ width: "2em", height: "4em" }} />
              </a>
              <a
                href="https://www.instagram.com/ebg.guatemala/?hl=es-la"
                target="_blank"
                style={{ color: "black", textDecoration: "none" }}
              >
                <InstagramIcon style={{ width: "2em", height: "4em" }} />
              </a>
              <a
                href="https://x.com/ABG_EBG"
                target="_blank"
                style={{ color: "black", textDecoration: "none" }}
              >
                <XIcon style={{ width: "2em", height: "4em" }} />
              </a>
              <a
                href="https://wa.me/+50230316000"
                target="_blank"
                style={{ color: "black", textDecoration: "none" }}
              >
                <WhatsAppIcon style={{ width: "2em", height: "4em" }} />
              </a>
              <a
                href="https://www.linkedin.com/company/escuela-bancaria-de-guatemala/"
                target="_blank"
                style={{ color: "black", textDecoration: "none" }}
              >
                <LinkedInIcon style={{ width: "2em", height: "4em" }} />
              </a>
              <a
                href="mailto:ebg@ebg.edu.gt"
                target="_blank"
                style={{ color: "black", textDecoration: "none" }}
              >
                <EmailIcon style={{ width: "2em", height: "4em" }} />
              </a>
              <a
                href="tel:+50223827223"
                target="_blank"
                style={{ color: "black", textDecoration: "none" }}
              >
                <LocalPhoneIcon style={{ width: "2em", height: "4em" }} />
              </a>
            </Stack>
          </Box>
        </Stack>{" "}
      </Box>
      <ScrollTop {...props}>
        <Stack spacing={2}>
          <Button
            style={{
              color: "black",
              backgroundColor: "#C5C5C5",
              fontWeight: "bold",
              border: "2px solid #e0721d",
              animation: 'pixelate 0.5s infinite alternate',
              fontSize: "1.2em",
              padding: "10px 30px",
              marginBottom: "20px",
            }}
            startIcon={<DrawIcon />}
            href={`${process.env.REACT_APP_URL_INSCRIPCION}${process.env.REACT_APP_EVT}`}
            target="_blank"
          >
            Inscríbete en línea
          </Button>
          <Fab size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </Stack>
      </ScrollTop>
    </React.Fragment>
  );
}
